import { cx } from '@utils/cx';
import { useTranslation } from 'react-i18next';

import { contractModels } from '..';

const className = 'rounded-[16px] py-[2px] px-[8px] text-[12px] leading-[18px] font-medium';

export const signatureStatuses = ({
  status
}: {
  status: contractModels.IOnlineContractClientSignatureId['status'] | (string & {});
}) => {
  const { t } = useTranslation();

  return (
    {
      SIGNED: <span className={cx(className, 'bg-success-50 text-success-700')}>{t('global.Imzolangan')}</span>,
      SIGNED_BY_CLIENT: (
        <span className={cx(className, 'bg-blue-50 text-blue-700')}>{t('global.Mijoz_imzolagan')}</span>
      ),
      UNSIGNED: <span className={cx(className, 'bg-gray-100 text-gray-700')}>{t('global.Imzolanmagan')}</span>,
      CANCELED: <span className={cx(className, 'bg-error-100 text-error-700')}>{t('home.Bekor_qilingan')}</span>,
      SIGNED_BY_BUILDER: <span className={cx(className, 'bg-blue-50 text-blue-500')}>{t('home.Kutilmoqda')}</span>
    } as Record<string, React.ReactElement>
  )?.[status];
};
